import {
  MiniKit,
  type SendTransactionInput,
  Tokens,
  tokenToDecimals,
} from '@worldcoin/minikit-js';
import { CONSTANTS } from '@/constants';
import { ReferenceResponse } from './useBuyChest';

const ABI = [
  {
    type: 'function',
    name: 'signatureTransfer',
    inputs: [
      {
        name: 'permitTransferFrom',
        type: 'tuple',
        internalType: 'struct ISignatureTransfer.PermitTransferFrom',
        components: [
          {
            name: 'permitted',
            type: 'tuple',
            internalType: 'struct ISignatureTransfer.TokenPermissions',
            components: [
              {
                name: 'token',
                type: 'address',
                internalType: 'address',
              },
              {
                name: 'amount',
                type: 'uint256',
                internalType: 'uint256',
              },
            ],
          },
          { name: 'nonce', type: 'uint256', internalType: 'uint256' },
          { name: 'deadline', type: 'uint256', internalType: 'uint256' },
        ],
      },
      {
        name: 'transferDetails',
        type: 'tuple',
        internalType: 'struct ISignatureTransfer.SignatureTransferDetails',
        components: [
          { name: 'to', type: 'address', internalType: 'address' },
          {
            name: 'requestedAmount',
            type: 'uint256',
            internalType: 'uint256',
          },
        ],
      },
      { name: 'referenceId', type: 'string', internalType: 'string' },
      { name: 'signature', type: 'bytes', internalType: 'bytes' },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
];

const WLD_ADDRESS = '0x2cFc85d8E48F8EAB294be644d9E25C3030863003';

export async function transferWLD(
  data: {
    data: {
      referenceId: string;
      amount: number;
    };
  },
  toAddress: string,
) {
  const CONTRACT = CONSTANTS.CONTRACT_PAY_TRANSFER;
  if (!CONTRACT) {
    throw new Error('Invalid Contract');
  }
  const permitTransfer = {
    permitted: {
      token: WLD_ADDRESS, // The token I'm sending,
      amount: tokenToDecimals(data.data.amount, Tokens.WLD).toString(),
    },
    nonce: Date.now().toString(),
    deadline: Math.floor((Date.now() + 30 * 60 * 1000) / 1000).toString(),
  };

  const transferDetails = {
    to: toAddress,
    requestedAmount: tokenToDecimals(data.data.amount, Tokens.WLD).toString(),
  };

  const payload: SendTransactionInput = {
    transaction: [
      {
        address: CONTRACT,
        abi: ABI,
        functionName: 'signatureTransfer',
        args: [
          [
            [permitTransfer.permitted.token, permitTransfer.permitted.amount],
            permitTransfer.nonce,
            permitTransfer.deadline,
          ],
          [transferDetails.to, transferDetails.requestedAmount],
          data.data.referenceId,
          'PERMIT2_SIGNATURE_PLACEHOLDER_0', // Placeholders will automatically be replaced with the correct signature.
        ],
      },
    ],
    permit2: [
      {
        ...permitTransfer,
        spender: CONTRACT,
      }, // If you have more than one permit2 you can add more values here.
    ],
    formatPayload: false,
  };
  console.debug('Payload: ', payload);

  const response = await MiniKit.commandsAsync.sendTransaction(payload);
  console.log('finalPayload: ', response);
  return response;
}
